module.exports = __webpack_public_path__ + "media/images/people/girl-12-ad0e47667863c24980dd2f6dd3890f93.webp";